import { render } from "./WebinarPage.vue?vue&type=template&id=61f42248"
import script from "./WebinarPage.vue?vue&type=script&lang=ts"
export * from "./WebinarPage.vue?vue&type=script&lang=ts"
script.render = render

export default script